// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"411":"9a60d049","571":"ecaf9f2f","776":"4c87c7d5","878":"198b6ea4","966":"3c72ad7d"}[chunkId] + ".css";
};